// store/authorizedPayersSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../api/axiosInstance';

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api/settings/authorized-payers/`;

export const fetchAuthorizedPayers = createAsyncThunk(
  'authorizedPayers/fetchAll',
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(BASE_URL);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Fetch failed');
    }
  }
);

export const addAuthorizedPayer = createAsyncThunk(
  'authorizedPayers/add',
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post(BASE_URL, payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Add failed');
    }
  }
);

export const updateAuthorizedPayer = createAsyncThunk(
  'authorizedPayers/update',
  async ({ id, ...data }, thunkAPI) => {
    try {
      const response = await axios.put(`${BASE_URL}${id}/`, data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Update failed');
    }
  }
);

export const deleteAuthorizedPayer = createAsyncThunk(
  'authorizedPayers/delete',
  async (id, thunkAPI) => {
    try {
      await axios.delete(`${BASE_URL}${id}/`);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Delete failed');
    }
  }
);

const authorizedPayersSlice = createSlice({
  name: 'authorizedPayers',
  initialState: {
    items: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuthorizedPayers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAuthorizedPayers.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchAuthorizedPayers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addAuthorizedPayer.fulfilled, (state, action) => {
        state.items.push(action.payload);
      })
      .addCase(updateAuthorizedPayer.fulfilled, (state, action) => {
        const index = state.items.findIndex(item => item.id === action.payload.id);
        if (index !== -1) {
          state.items[index] = action.payload;
        }
      })
      .addCase(deleteAuthorizedPayer.fulfilled, (state, action) => {
        state.items = state.items.filter(item => item.id !== action.payload);
      });
  }
});

export default authorizedPayersSlice.reducer;
